export const useCourseProgressProp = () => {}